/**
 * This file contains all the necessary configuration settings
 * for firebase to work. Adapted from Dr. Toal's notes.
 */

import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'

// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration

const firebaseConfig = {
  apiKey: 'AIzaSyB5_OM1assJ54mG6mp5AhKY6P-nXU3LhMU',

  authDomain: 'simple-blog-98e62.firebaseapp.com',

  projectId: 'simple-blog-98e62',

  storageBucket: 'simple-blog-98e62.appspot.com',

  messagingSenderId: '494300367322',

  appId: '1:494300367322:web:e5b2635a2c540e330c98e3'
}

// Initialize Firebase

const app = initializeApp(firebaseConfig)
const auth = getAuth(app)
const db = getFirestore(app)

export { app, auth, db }
